(function($){
  
  $(document).ready(function(){

    if (window.location.pathname.includes('products')) {
      enableMobileZoom();
    }
    
    $('.related-prod.for-slick .flex-container.for-upsells').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      prevArrow: $('.related-prod.for-slick .left-arrow'),
      nextArrow: $('.related-prod.for-slick .right-arrow'), 
      infinite: false,
      variableWidth: false,
      responsive: [
        {
          breakpoint: 1920,
          settings: {
            slidesToShow: 5
          }
        },              
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3
          }
        }
      ]          
    });
  
    $('.prod-image-section .display-lists.for-slick').slick({
      slidesToShow: 1,
      dots: true,
      infinite: false,
      speed: 300,
      prevArrow: false,
      nextArrow: false
    });
  
    //product info dropdown
    $('.header-button').click(function(){
      var $this = $(this),
        $parent = $this.parent(),
          panel = $('.info-sidepanel'),
          label = $this.data('label'),
          panelBtn = $(`.info-sidepanel-btn[data-label="${label}"]`),
          rte = $(`.info-sidepanel-rte[data-label="${label}"]`),
          container = $('.main-product-info').offset(),
          userViewport = $(window).width();
      
      if(userViewport > 1024) {

        panel.addClass('active');
        panelBtn.addClass('active').siblings().removeClass('active');
        rte.addClass('active').siblings().removeClass('active')

        var contentOffset = container

        contentOffset.top = contentOffset.top;

        contentOffset.right = contentOffset.right;

        scrollIntoView(contentOffset.top, contentOffset.left)
      }
    })
    
    

    function scrollIntoView(top, right) {
      $('html, body').animate({
        scrollTop: top,
        scrollRight: right
      });
    }
    
    
    $('.info-sidepanel-close-btn').click(function() {
      var panel = $(this).closest('.info-sidepanel.active');
      
      panel.removeClass('active');
    });
    
    $('.info-sidepanel-btn').click(function() {
      var $this = $(this),
          info = $this.data('label'),
          panel = $this.closest('.info-sidepanel-inner').find(`.info-sidepanel-rte[data-label="${info}"]`),
          userViewport = $(window).width();
      
      $this.addClass('active').siblings().removeClass('active');
      
      if(userViewport > 1024) {
        panel.addClass('active').siblings().removeClass('active');
      }
    });
    
    var tabletProductDetailSlider = $('.info-sidepanel-content.mob');
    
    tabletProductDetailSlider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
      mobileFirst: true,
      arrows: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: 'unslick'
        }
      ]
    });
    
    $('.info-sidepanel.mob .info-sidepanel-btn').click(function() {
      var $this = $(this),
          index = $this.index()
      
      tabletProductDetailSlider.slick('slickGoTo', index);
    })

    // On before slide change
    tabletProductDetailSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
      var activeBtn = $('.info-sidepanel.mob .info-sidepanel-btn').eq(nextSlide)
      
      activeBtn.addClass('active').siblings().removeClass('active')
    });
    
    tabletProductDetailSlider.on('afterChange', function(event, slick, currentSlide, nextSlide){
      	var lastSlide = slick.slideCount - 1
        if(currentSlide === lastSlide) {
          slick.options.swipe = false;
        }else {
          slick.options.swipe = true;
        }
      });
    
    $('.sr-overlay-bg').click(function() {
      toggleSRDetails();
    })
    
    $('.sr-header button').click(function() {
      toggleSRDetails();
    })
    
    $('.sr-btn button').click(function() {
      toggleSRDetails();
    })

    function toggleSRDetails() {
      var sr = $('.sr-details-main')

      sr.fadeToggle(function() {
        $('html, body').toggleClass('scroll-hidden');
      })
    }
    
    $('#qty-button').click(function(){
        var $this = $(this),
            $qtySelect = $this.siblings('.quantity-select')
      
          $this.toggleClass('active');
          $qtySelect.toggle("slide")
      
        })
    //change Quantity Value on select
    $('.item-qty .quantity-selector.unique-class').change(function(){
    var $this = $(this),
    $value = $this.children("option:selected").val(),
    $qtyData = $this.closest('.qty-price-section').siblings('.product-details').find('.cart__qty-input.qty-data')
    
    $qtyData.val($value)
    $this.siblings('.update-action').trigger('click')
    })    
    $('.related-prod.slick-mob.slick-init .flex-container.for-upsells.slick-init').slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      prevArrow: $('.related-prod.slick-mob .left-arrow'),
      nextArrow: $('.related-prod.slick-mob .right-arrow'),
      responsive: [
        {
          breakpoint: 1920,
          settings: {
            slidesToShow: 5,
          }
        },
        {
          breakpoint: 1279,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 3
          }
        }
  
      ]
    });  
  //popin size guide
  $(".size-guide-trigger").click(function(e){
    e.preventDefault();
    if($(window).width() < 1024) {
      $('.popUpBannerBox').show();
      var $modal = $('#size-guide-popup-mobile');
      $modal.addClass('open');
    }
  });
  $(".closePopUp").click(function(){
      $(".popUpBannerBox").hide();
  });
  
  
  $('.size_chart_select_wrap').click(function() {
    var $this = $(this),
        sizeSelection = $this.find('.sizechartDropdown');
    
    sizeSelection.slideToggle();
  });
  
    //show inches to cm unit
  
  $('.inches_btn').click(function() {
    var $this = $(this);
    $this.addClass('active').siblings().removeClass('active');
    $('.inches_unit').removeClass('chartHide');
    $('.cm_unit').addClass('chartHide');
  });
    
   $('.cm_btn').click(function() {
    var $this = $(this);
    $this.addClass('active').siblings().removeClass('active');
    $('.cm_unit').removeClass('chartHide');
    $('.inches_unit').addClass('chartHide');
    
  });
  
  
  //Load size chart on click category selection mens, womens, etc...
  $('#fitter-selection li').click(function() {
    var $this = $(this);
    var selectedText = $this.text();
    var changeText = $('.currentDivision');
    var filterData = $this.attr("data-division");
    var catData = $('.size_chart_select_wrap[data-parent]');
    var parentData = $('.size_chart_select_wrap[data-parent="' + filterData + '"]');
    var dataText = parentData.attr("data-parent");
    var dataContainer = $('.size-charts[data-container]');
    var valueContainer = $('.size-charts[data-container="' + filterData + '"]');
    var containerText = valueContainer.attr("data-container");
    
    //replace category text to the selected text
    changeText.text(selectedText);
    //temporarily hide the size charts
    catData.hide();
  
    
   
    if (filterData == containerText ) {
      //show size chart 
      valueContainer.show().siblings('.size-charts[data-container]').hide();
      //reload 2nd category
      parentData.show().siblings('.size_chart_select_wrap[data-parent]').hide();
      //show 2nd dropdown category
      parentData.show();
    }
    
  });    
  
  
  //Load size chart on click 2nd category selections tops, jeans, etc....
  $('li[data-content]').click(function() {
    var $this = $(this);
    var text = $this.text();
    var textAttr = $this.attr("data-content");
    var curText = $('.currentCategory').text(text);
    var containerChildren = $('.size_chart_data_wrap[data-children]')
    var catChildren = $('.size_chart_data_wrap[data-children="' + textAttr +'"]');
    var childrenAttr = catChildren.attr("data-children");
    
  // console.log(childrenAttr);
    if ( textAttr == childrenAttr) {
      //show size chart
      catChildren.show().siblings().hide();
      
    }
  });
    $(document).on('click', '.size-guide-bg',function(e){
      // console.log()
      $(e.target) == $('.popUpBannerBox');
      var $modal = $('#size-guide-popup');
      if($modal.hasClass('open')){
        $modal.removeClass('open').hide()
      }
    });

    if($('body').hasClass('template-product')){
      var productTags = theme.productTags,
          divMen = productTags.includes('MS-bottom') || productTags.includes('MS-top') || productTags.includes('MS-accessories'),
          divWomen = productTags.includes('WS-bottom') || productTags.includes('WS-top') || productTags.includes('WS-accessories'),
          divBoys = productTags.includes('KBS-bottom') || productTags.includes('KBS-top') ,
          divGirls = productTags.includes('KGS-bottom') || productTags.includes('KGS-top') || productTags.includes('KGS-accessories'),
          divTeenG = productTags.includes('TGS-bottom') || productTags.includes('TGS-top'),
          divTeenB = productTags.includes('TGB-bottom') || productTags.includes('TGB-top'),
          divToddlers = productTags.includes('Gap Toddler Boys') || productTags.includes('TDS-apparel') || productTags.includes('Toddler') || productTags.includes('Gap Toddler Girls'),
          divBaby = productTags.includes('BS-apparel') || productTags.includes('BS-accessories'),

          McatTop = productTags.includes('MS-top'),
          McatBottom = productTags.includes('MS-bottom'),
          McatAccessories = productTags.includes('MS-accessories'),
          
          WcatTop = productTags.includes('WS-top'),
          WcatBottom = productTags.includes('WS-bottom'),
          WcatAccessories = productTags.includes('WS-accessories'),
          
          TGcatTop = productTags.includes('TGS-top') || productTags.includes('TGS-bottom'),
          
          TBcatTop = productTags.includes('TGB-top') || productTags.includes('TGB-bottom'),
          
          KGcatTop = productTags.includes('KGS-top'),
          KGcatBottom = productTags.includes('KGS-bottom'),
          KGcatAccessories = productTags.includes('KGS-accessories'),
          
          KBcatTop = productTags.includes('KBS-top'),
          KBcatBottom = productTags.includes('KBS-bottom'),
          
          TDcatApparel = productTags.includes( 'TDS-apparel'),
          TDcatAccessories = productTags.includes('TDS-accessories'),
          
          BScatApparel = productTags.includes('BS-apparel'),
          BScatAccessories = productTags.includes('BS-accessories')

      // console.log(divMen, ' ', divWomen, ' ', divBoys, ' ', divGirls, ' ', divToddlers, ' ', divBaby);

      if(divMen){
        $('#fitter-selection li[data-division="mens"]').trigger('click').trigger('click');
        if(McatTop){
          $('li[data-category="Mtops"]').trigger('click').trigger('click');
        }else if(McatBottom){
          $('li[data-category="Mbottoms"]').trigger('click').trigger('click');
        }else if(McatAccessories){
          $('li[data-category="Mshoes"]').trigger('click').trigger('click');
        }
      }else if(divWomen){
        $('#fitter-selection li[data-division="womens"]').trigger('click').trigger('click');
        if(WcatTop){
          $('li[data-category="Wtops"]').trigger('click').trigger('click');
        }else if(WcatBottom){
          $('li[data-category="Wjeans"]').trigger('click').trigger('click');
        }else if(WcatAccessories){
          $('li[data-category="Wshoes"]').trigger('click').trigger('click');
        }
      }else if(divBoys){
        $('#fitter-selection li[data-division="boys"]').trigger('click').trigger('click');
        if(KBcatTop){
          $('li[data-category="Btops"]').trigger('click').trigger('click');
        }else if(KBcatBottom){
          $('li[data-category="Bbottoms"]').trigger('click').trigger('click');
        }
      }else if(divGirls){
        $('#fitter-selection li[data-division="girls"]').trigger('click').trigger('click');
        if(KGcatTop){
          $('li[data-category="Gtops"]').trigger('click').trigger('click');
        }else if(KGcatBottom){
          $('li[data-category="Gbottoms"]').trigger('click').trigger('click');
        }else if(KGcatAccessories){
          $('li[data-category="Gshoes"]').trigger('click').trigger('click');
        }
      }else if(divTeenG){
        $('#fitter-selection li[data-division="teenGirl"]').trigger('click').trigger('click');
        if(TGcatTop){
          $('li[data-category="TGtops"]').trigger('click').trigger('click');
        }
      }else if(divTeenB ){
        $('#fitter-selection li[data-division="teenBoy"]').trigger('click').trigger('click');
        if(TBcatTop){
          $('li[data-category="TBtops"]').trigger('click').trigger('click');
        }
      }else if(divToddlers){
        $('#fitter-selection li[data-division="toddler"]').trigger('click').trigger('click');
        if(TDcatApparel){
          $('li[data-category="TDapparel"]').trigger('click').trigger('click');
        }else if(TDcatAccessories){
          $('li[data-category="TDshoes"]').trigger('click').trigger('click');
        }
      }else if(divBaby){
        $('#fitter-selection li[data-division="newborn"]').trigger('click').trigger('click');
        if(BScatApparel){
          $('li[data-category="BBbaby"]').trigger('click').trigger('click');
        }else if(BScatAccessories){
          $('li[data-category="BBshoes"]').trigger('click').trigger('click');
        }
      }

    }
    
  $('.ui-accordion-header').click(function() {
    var $this = $(this);
    var idAttr = $this.attr("id");
    // console.log(idAttr);
    setTimeout(function(){
      	$this.find('.ui-accordion-header-icon').toggleClass('icon-plus icon-minus');
        $this.siblings('.ui-accordion-content[aria-labelledby="' + idAttr + '"]').slideToggle();
    }, 300);
  });
    // $(window).on('load',function(){
    //   var sizeOptions = $('.swatch-attribute.size .size-list li');
    //   if(sizeOptions.length == 1){
    //     sizeOptions.trigger('click');
    //   }
    // });
    
//     pause/play video
    $('.js-play-video').click(function() {
      var $this = $(this),
          button = $this.find('.product-photo--video-icon'),
          video = $this.parent().find('video').get(0);
      
      
      if(video.paused === true) {
        video.play();
        button.hide();
      }else {
        video.pause();
        button.show();
      }
    })
    
    
    
    // Probably for past slider but is not used anymore so I'll just keep it -Rengie
    // $('.shirts-deskflick2').slick({
    //   slidesToShow: 1,
    //   slidesToScroll: 1,
    //   prevArrow: $('.shirtmen-prev2'),
    //   nextArrow: $('.shirtmen-next2'),  
    //   infinite: true
    // })     
    
    // $('.shirts-deskflick').slick({
    //   slidesToShow: 1,
    //   slidesToScroll: 1,
    //   prevArrow: $('.shirtmen-prev'),
    //   nextArrow: $('.shirtmen-next'), 
    //   infinite: true
    // })
    
    // $('.shirts-deskflickmain').slick({
    //   slidesToShow: 1,
    //   slidesToScroll: 1,
    //   prevArrow: $('.shirtmen-prevmain'),
    //   nextArrow: $('.shirtmen-nextmain'), 
    //   infinite: true
    // })    
    
   
    // -Commented by Rengie
    
    // for lexer
    $('#AddToCart-gap-product-temp button').click(function(e){
      e.preventDefault();
        var $btn = $(this);
        var product = theme.currentSelectedProduct;
        var variant = theme.currentSelectedVariant;
        var quantityToAdd = parseInt($('.qty-selections input[name="quantity"]').val());
        
        if(product || variant) {
          // Check cart state before attempting to add
          checkCartStateBeforeAdd(variant.id, quantityToAdd, product, variant, $btn);
        }
    });
    
  })

  // Function to check cart state before adding items
  function checkCartStateBeforeAdd(variantId, quantity, product, variant, $btn) {
    // Remove any existing error message first
    removeMaxQuantityError();
    
    // Fetch current cart state
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        // Check if this variant is already in cart
        var existingItem = cart.items.find(item => item.variant_id === variantId);
        var currentQuantity = existingItem ? existingItem.quantity : 0;
        var totalQuantity = currentQuantity + quantity;
        
        // Get the actual inventory quantity for this variant
        var maxQuantity = variant.inventory_quantity || 0;
        
        // Check if adding this quantity would exceed the available inventory
        if (totalQuantity > maxQuantity) {
          // Show error and disable button
          showMaxQuantityError();
          disableAddToCartButton($btn);
          return;
        }
        
        // If validation passes, enable button and proceed with adding to cart
        enableAddToCartButton($btn);
        addToCartWithErrorHandling(variantId, quantity, product, variant, $btn);
      })
      .catch(error => {
        console.error('Error checking cart state:', error);
        // If cart check fails, proceed with normal add to cart
        enableAddToCartButton($btn);
        addToCartWithErrorHandling(variantId, quantity, product, variant, $btn);
      });
  }

  // Function to disable add to cart button
  function disableAddToCartButton($btn) {
    $btn.prop('disabled', true);
    $btn.addClass('disabled');
    $btn.text('Add to bag');
  }

  // Function to enable add to cart button
  function enableAddToCartButton($btn) {
    $btn.prop('disabled', false);
    $btn.removeClass('disabled');
    $btn.text('Add to bag');
  }

  // Function to remove error message
  function removeMaxQuantityError() {
    var errorElement = document.getElementById('max-quantity-error-inline');
    if (errorElement) {
      errorElement.remove();
    }
  }

  // Function to add to cart with proper error handling for 422 responses
  function addToCartWithErrorHandling(variantId, quantity, product, variant, $btn) {
    // Prepare form data
    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', quantity);
    
    // Make AJAX request to cart/add.js
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(response => {
      if (response.ok) {
        // Success - item added to cart
        return response.json();
      } else {
        // Handle error responses
        return response.json().then(errorData => {
          throw { status: response.status, data: errorData };
        });
      }
    })
    .then(data => {
      // Success - trigger analytics and update UI
      gtag("event", "add_to_cart", {
        currency: "PHP",
        items: [{
          'item_id': product.id.toString(),
          'item_name': product.title,
          'currency': 'PHP',
          'item_brand': product.vendor,
          'item_category': product.type,
          'item_variant': variant.title,
          'price': variant.price * 0.01,
          'quantity': quantity
        }]
      });
      
      dataLayer.push({ ecommerce: null });
      dataLayer.push({
        'event': 'addToCart',
        'ecommerce': {
          'currencyCode': 'PHP',
          'add': {
            'products': [{
              'id': product.id.toString(),
              'name': product.title,
              'price': variant.price * 0.01,
              'brand': product.vendor,
              'category': product.type,
              'variant': variant.title,
              'quantity': quantity
            }]
          }
        }
      });
      
      // Dispatch cart updated event
      document.dispatchEvent(new CustomEvent('cart:updated', { 
        detail: { cart: { item_count: theme.cart.items.length } },
        bubbles: true 
      }));
      
      // Update cart count if element exists
      var countLabel = document.querySelector('.shopping-bag-count');
      if (countLabel) {
        countLabel.textContent = parseInt(countLabel.textContent) + quantity;
      }
      
      // Redirect to cart page after successful add
      window.location.href = '/cart';
    })
    .catch(error => {
      // Handle 422 error (maximum quantity reached)
      if (error.status === 422) {
        showMaxQuantityError();
      } else {
        // Handle other errors
        console.error('Add to cart error:', error);
        alert('There was an error adding the item to your cart. Please try again.');
      }
    });
  }

  // Function to show maximum quantity error message inline
  function showMaxQuantityError() {
    // Remove any existing error message
    var existingError = document.getElementById('max-quantity-error-inline');
    if (existingError) {
      existingError.remove();
    }
    
    // Create inline error message above the quantity/add to bag section
    var errorHtml = `
      <div id="max-quantity-error-inline" style="
        background: #fff;
        border-left: 3px solid #e74c3c;
        border-radius: 4px;
        padding: 12px 16px;
        margin-bottom: 12px;
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 14px;
        color: #333;
        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
      ">
        <div style="
          width: 16px;
          height: 16px;
          background: #e74c3c;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-weight: bold;
          font-size: 12px;
          flex-shrink: 0;
        ">!</div>
        <div style="
          display: flex;
          flex-direction: column;
          gap: 4px;
        ">
          <div style="
            font-size: 16px;
            font-weight: bold;
            color: #333;
            line-height: 1.2;
          ">Sorry, There was a problem</div>
          <div style="
            font-size: 12px;
            color: #666;
            line-height: 1.3;
          ">You have added this item to your shopping cart up to the maximum quantity.</div>
        </div>
      </div>
    `;
    
    // Find the quantity section (add-to-bag-cta) and insert error above it
    var quantitySection = document.querySelector('.add-to-bag-cta');
    if (quantitySection) {
      quantitySection.insertAdjacentHTML('beforebegin', errorHtml);
    }
  }

  // Function to close the error message
  function closeMaxQuantityError() {
    var errorElement = document.getElementById('max-quantity-error-inline');
    
    if (errorElement) {
      errorElement.remove();
    }
  }

  // Make closeMaxQuantityError globally available
  window.closeMaxQuantityError = closeMaxQuantityError;


  $(window).on('load', function() {
    const isPreviewDomain = window.location.hostname.includes('shopifypreview.com');
    const isPreviewKeyPresent = window.location.search.includes('preview_key');
    const isProductPage = window.location.pathname.startsWith('/products/');
    const availability = $('#availabity-rdrect').data('available');

    // console.log('Preview domain:', isPreviewDomain);
    // console.log('Preview key in URL:', isPreviewKeyPresent);
    // console.log('Is product page:', isProductPage);
    // console.log('Availability:', availability);

    if (
      !isPreviewDomain &&
      isProductPage &&
      !isPreviewKeyPresent &&
      availability === false
    ) {
      console.log('OUT OF STOCK — redirecting');
      window.location.href = "https://gap.com.ph/pages/oos-404";
    } else {
      console.log('No redirect — either preview or in stock');
    }
  });

  function getSameProduct(maintitle, styleNumber) {
    const title  = maintitle,
          search_url = `https://${window.location.hostname}/search?view=json&q=${encodeURIComponent(title)}`,
          results = null;
    $.ajax({
      url: search_url,
      method: "GET",
      success: function(data) {
        var data = JSON.parse(data),
            dresults = data.results.filter(result => result.title === title && parseInt(result.style_number) == parseInt(styleNumber) && result.available);
        
        buildColorSelection(dresults)
      },
      error: function(error) {
        console.log(error)
      }
    });
  }
  var selectedColor = $('#curr_color').data('current-color'),
      prodTitle = $('.prod-title').eq(0).text().trim();
    
  if (prodTitle.indexOf(selectedColor) >= 0) {
    prodTitle = prodTitle.replace(selectedColor, '');
  }
  
  var handleWithoutColor = currentProduct.handle.replace(`-${currentProduct.color_handleize}`, ''),
      lastIndex = handleWithoutColor.length - 7,
      removeNotNumber = handleWithoutColor.replace(`${currentProduct.title_handleize}-`, ''),
      styleNumber = removeNotNumber.includes('undefined') ? removeNotNumber.replace('undefined', '') : removeNotNumber;

  getSameProduct(currentProduct.title, currentProduct.style_number)
  
  function handleize(str) {
    return str.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
  }

  function buildColorSelection(items) {
    var theme = window.theme || {},
        colorsTpl = '',
        currentColor = currentProduct.color;
    
    theme.similarItems = items;
    
    var uColor = []

    items.map(item => {
      
      if(!uColor.includes(item.color)) {
      
        var template = swatchTpl

        template = template.replace(/{{selected}}/g, item.color === currentColor ? 'selected' : '');
        template = template.replace(/{{colorValue}}/g, item.color);
        template = template.replace(/{{valuethumb}}/g, item.swatch);
        template = template.replace(/{{valuethumb2}}/g, `${item.swatch}?v=c`);
        template = template.replace(/{{handleizeValue}}/g, handleize(item.color));
        template = template.replace(/{{available}}/g, item.available ? 'available' : 'disabled');

        colorsTpl += template
        uColor.push(item.color)
      }
    })

    $('.swatch-option .color-container').html(colorsTpl);
    $(`.swatch-btn.clr[option-label="${currentColor}"]`).trigger('click');

  }
  $(document).on('click', '.color-container .swatch-btn:not(.disabled)', function() {
    var $this = $(this),
        color = $this.find('input').val(),
        product = theme.similarItems.filter(item => item.color === color)[0],
        media = product.media,
        images = product.media.filter(media => media.media_type === 'image'),
        firstAvailableVariant = product.variants.filter(variant => variant.available )[0];

    // Remove any existing error message when color changes
    removeMaxQuantityError();

    $this.addClass('selected').siblings().removeClass('selected')

    theme.currentSelectedProduct = product;

    buildVariantOptions(product)
    updateVariantId(firstAvailableVariant)
    replaceImages(images)
    updateUrl(product, firstAvailableVariant)
    updatePrice(firstAvailableVariant)
    updateTitle(product.title)
  })

  $(document).on('click', '.prod-image-section .prod-grid-thumb .prod-media-container', function(e) {
    e.preventDefault();
    var $this = $(this),
        index = $this.index(),
        mainImg = $('.prod-image-section .prod-media-grid .prod-media-container');

    $this.addClass('media_active').siblings().removeClass('media_active')
    mainImg.eq(index).addClass('media_active').siblings().removeClass('media_active')
  })


  $(document).on('click', '.size-list .swatch-btn', function() {
    var $this = $(this),
        label = $this.closest('.size-container').siblings('.swatch-label-size').find('.selected-input'),
        value = $this.find('input').val(),
        cartBtn = $('#AddToCart-gap-product-temp button'),
        product = theme.similarItems.filter(item => item.color === $('.color-container .swatch-btn.selected input').val())[0];

    // Remove any existing error message when variant changes
    removeMaxQuantityError();

    if($this.hasClass('disabled')) {
      $('#oos-colsiz').css('display', 'flex')
      cartBtn.addClass('disabled').attr('disabled')
    } else {
      $('#oos-colsiz').css('display', 'none')
    }
    
    $this.addClass('selected').siblings().removeClass('selected');
    label.text(value)
    
    var selectedValues = [],
        selectedVariant = null;
          
    $('.swatch-option[data-option-index]').each((i, element) => {
      var $this = $(element),
          index = $this.data('option-index'),
          value = $this.find('.swatch-btn.selected input').val();
      selectedValues.push({
        index: index,
        value: value || null
      });
    })
    
    updateAvailableVariants(product.variants, selectedValues);
    
    selectedVariant = product.variants.find(function(variant) {
      return selectedValues.every(function(values) {
        return variant.options[values.index] === values.value;
      })
    })
    
    if(selectedVariant) {
      theme.currentSelectedVariant = selectedVariant;
      var $curqty = $('#qty-button').data("currqty", selectedVariant.inventory_quantity);
      updateVariantId(selectedVariant)
      updateUrl(product, selectedVariant)
      
      if(selectedVariant.available) {
        cartBtn.removeClass('disabled').removeAttr('disabled')
      } else {
        cartBtn.addClass('disabled').attr('disabled', '')
      }
    }
  })
  
  function updateAvailableVariants(variants, values) {
    if(!variants || !values) return;
    
    
    values = values.filter(item => item.value)
    
    var highlighted_values = variants.filter(function(variant) {
      return values.every(function(val) {
        var title_found = variant.title.split(' / ')[val.index] === val.value;
        return title_found;
      })
    });
    
    
    var options = $('.swatch-option[data-option-index]');
    
    options.each((i, option) => {
      var $option = $(option),
          $index = parseInt($option.data('option-index')),
          has_selected = values.find(val => val.index === $index) || null;
      
      if(!has_selected) {
        $option.find('.size-list .swatch-btn').each((ind, value_container) => {
          var $value_container = $(value_container),
              $value = $value_container.find('input').val(),
              target_value = highlighted_values.find(variant => {
                var title_found = variant.title.split(' / ')[$index] === $value;
                return title_found && variant.available
              }),
              is_available = target_value ? true : false;
          
          if(is_available) {
            $value_container.removeClass('disabled');
          }else{
            $value_container.addClass('disabled').removeClass('selected');
          }
        })
      }
    })
  }

  function buildVariantOptions(product) {
    var options = product.options_with_values,
        colorIndex = options.findIndex(option => option.name === 'Color'),
        sizeIndex = options.findIndex(option => option.name === 'Size'),
        waistIndex = options.findIndex(option => option.name === 'Waist'),
        lengthIndex = options.findIndex(option => option.name === 'Length'),
        variants = product.variants,
        currentColor = product.color,
        sizeTpl = '',
        waistTpl = '',
        lengthTpl = '',
        uSizes = [],
        uWaist = [],
        uLengths =[];
    
    options.map(option => {
      if(option.name === 'Size') {
        variants.map(variant => {
          var sizeVal = variant.title.split(' / ')[sizeIndex];
          var is_available = variants.filter(variant => variant.title.split(' / ')[sizeIndex] === sizeVal && variant.available).length > 0 ? true : false;
          var shortClass = sizeVal.includes('SHORT') ? 'short-class' : '';
          var additionalClass = sizeVal.includes('ONE SIZE') || sizeVal.includes('One Size') || sizeVal.includes('ONESIZE') || sizeVal.includes('YRS') || sizeVal.includes('yrs') || sizeVal.includes('12-18') || sizeVal.includes('18-24') ? 'onesize-class' : '';
          if(!uSizes.includes(sizeVal)) {
            sizeTpl += `<li class="swatch-btn swatch-option sz ${is_available ? 'available' : 'disabled'} ${sizeVal} ${shortClass} ${additionalClass}" data-swatch-index="1" data-value="${sizeVal}" option-label="${sizeVal}">
            <span style="justify-content: center; display: flex; height: 100%; align-items: center;">
              <span>${sizeVal}</span>
            </span>
            <input type="radio" id="swatch-1-${sizeVal}" name="option-1" value="${sizeVal}">
            </li>`
          }
          uSizes.push(sizeVal)
        })
      }else if(option.name === 'Waist') {
        variants.map(variant => {
          var waistVal = variant.title.split(' / ')[waistIndex]
          var is_available = variants.filter(variant => variant.title.split(' / ')[waistIndex] === waistVal && variant.available).length > 0 ? true : false;
          
          if(!uWaist.includes(waistVal)) {
              waistTpl += `<li class="swatch-btn swatch-option wst ${is_available ? 'available' : 'disabled'} ${waistVal}" data-swatch-index="1" data-value="${waistVal}" option-label="${waistVal}"><span style="justify-content: center; display: flex; height: 100%; align-items: center;"><span>${waistVal}</span></span>

                          <input type="radio" id="swatch-1-${waistVal}" name="option-1" value="${waistVal}">
                    </li>`
           }
          uWaist.push(waistVal)
        })
      }else if(option.name === 'Length') {
          variants.map(variant => {
            var lengthVal = variant.title.split(' / ')[lengthIndex]
            var is_available = variants.filter(variant => variant.title.split(' / ')[lengthIndex] === lengthVal && variant.available).length > 0 ? true : false;
            if(!uLengths.includes(lengthVal)) {
              lengthTpl += `<li class="swatch-btn swatch-option wdth swatch-element swatch-option text ${lengthVal} ${is_available ? 'available' : 'disabled'}" data-swatch-index="8" data-value="${lengthVal}" option-label="${lengthVal}"><span style="justify-content: center; display: flex; height: 100%; align-items: center;"><span>${lengthVal}</span></span>

        <input type="radio" id="swatch-2-${lengthVal}" name="option-2" value="${lengthVal}">
      </li>`
            }
            uLengths.push(lengthVal)
          })
      }
    })
    
    
      $('.size-container .size-list.size').html(sizeTpl)
      $('.size-container .size-list.waist').html(waistTpl)
      $('.size-container .size-list.length').html(lengthTpl)
      $('.swatch-label-color .selected-input').text(product.color)
      
      
  }
  function updateVariantId(variant) {
    if(variant) {
      var sectionId = $('#pr-section-id').val(),
          inputId = $(`#ProductID-${sectionId}`);

      inputId.val(variant.id).change();
    }else {
      return
    }
  }
      
  function updateUrl(product, variant) {
    if (!history.replaceState || !variant) {
      return;
    }

    // Get the base product URL without any query parameters
    var baseUrl = window.location.protocol + '//' + window.location.host + '/products/' + product.handle;
    
    // Create new URL with only the variant parameter
    var newurl = baseUrl + '?variant=' + variant.id;
    
    window.history.replaceState({ path: newurl }, '', newurl);
  }
  
  
      
  $('.prod-image-section .mobile-display .img-lists .mob-img-slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true
  });
  function replaceImages(images) {
    var featured_image = images[0],
        htmlTpl = '',
        thumbHtmlTpl = '';
    var main_grid_container = $('.prod-image-section .prod-media-grid');
    var thumb_grid_container = $('.prod-image-section .prod-grid-thumb');

    var multiple_img_callback = (image,i) => {
      var loop_index = i + 1;
      htmlTpl += `<div class="prod-media-container media-container-${image.id}${loop_index === 1 ? ' media_active' : ''}" data-media-index="${loop_index}">
      <div class="media-img-container img-${image.id}-${i} js-zoom" data-zoom="${Shopify.Products.resizeImage(image.src, 'master')}" style="position:relative;height:0;display:block;padding-bottom:${1/image.aspect_ratio*100}%;">
        <img
            alt="${image.alt}"
            data-sizes="auto"
            data-src="${Shopify.Products.resizeImage(image.src, '1x1').replace('_1x1.', '_{width}x.')}"
            width="${image.width}"
            height="${Math.ceil(1 / image.aspect_ratio * image.width)}"
            data-widths="[200, 300, 350, 400, 500, 525, 600, 650, 700, 800, 1000, 1200]"
            class="lazyload media-grid-img js-mobile-zoom"
            style="position:absolute;top:0;left:0;width:100%;height:100%;">
            <div class="hover-zoom-lens"></div>
      </div>
    </div>`
    thumbHtmlTpl += `<div class="prod-media-container media-container-${image.id}${loop_index === 1 ? ' media_active' : ''}" data-media-index="${loop_index}">
    <div class="media-img-container img-${image.id}-${i}" style="position:relative;height:0;display:block;padding-bottom:${1/image.aspect_ratio*100}%;">
      <img
          alt="${image.alt}"
          data-sizes="auto"
          data-src="${Shopify.Products.resizeImage(image.src, '1x1').replace('_1x1.', '_{width}x.')}"
          width="${image.width}"
          height="${Math.ceil(1 / image.aspect_ratio * image.width)}"
          data-widths="[200, 300, 350, 400, 500, 525, 600, 650, 700, 800, 1000, 1200]"
          class="lazyload media-grid-img"
          style="position:absolute;top:0;left:0;width:100%;height:100%;">
    </div>
  </div>`
    }

    images.length > 1 ? main_grid_container.removeClass('single-media') : main_grid_container.addClass('single-media');

    images.map(multiple_img_callback);

    main_grid_container.html(htmlTpl)
    thumb_grid_container.html(thumbHtmlTpl)

    if(main_grid_container.children().length > 0 && $(window).width() >= 1024) {
      initCustomZoom();
    }
    
    
    var mobItem = $('.prod-image-section .mobile-display .img-lists .mob-img-slider li')
    
    
    var mobEl = $('.prod-image-section .mobile-display .img-lists .mob-img-slider')

    if(mobEl.hasClass('slick-initialized')) {
      mobEl.slick('unslick');
      mobEl.empty()
      mobEl.html(htmlTpl)
    }

    var mobSlider = mobEl.slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true
    });
    
  }

  function updatePrice(variant) {
    var regularTpl = `<h5 class="price-highlight">
                    <span id="ProductPrice-br-product-temp">${theme.Currency.formatMoney(variant.price, theme.moneyFormat)}</span>
                  </h5>`,
        saleTpl = `<h5 class="price-highlight">
                    <span id="ProductPrice-br-product-temp">${theme.Currency.formatMoney(variant.price, theme.moneyFormat)}</span>
                  </h5>
                  <h5 class="markdown"><span id="ComparePrice-br-product-temp">${theme.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat)}</span></h5>
                `,
        priceContainer = $('.prod-order-section .prod-titleprice .prod-ec-details .prod-price')
    
                  
    
    if(variant.compare_at_price > variant.price) {
      priceContainer.html(saleTpl)
      priceContainer.addClass('sale')
    }else {
      priceContainer.html(regularTpl)
      priceContainer.removeClass('sale')
    }
  }

  
  function initCustomZoom() {
    var desktopZoom = $('.js-zoom');
    
    desktopZoom.click(function() {
      var $this = $(this)
      
      $this.addClass('on-zoom')
    })
    
    function destroyZoom($this) {
      $this.trigger('zoom.destroy');
    }
    
    function zoomOptions($this) {

      var zoomOptions = {
        url: $this.data('zoom'),
        on: 'click',
        target: $('.zoomedMainContainer'),
        touch: false,
        magnify: 1,
        onZoomIn : function() {
          var image = this,
              container = $('.zoomedMainContainer'),
              lens = $this.find('.hover-zoom-lens'),
              lensWidth = $this.width() * (container.width() / $(this).width()),
              lensHeight = $this.find('img').height() * (container.height() / $(this).height());
          
          var lensCss = {
            'opacity' : '1',
            'width' : `${lensWidth}px`,
            'height' : `${lensHeight}px`
          }
          
          $this.addClass('on-zoom');
          container.show();
          
          $('.prod-order-container').hide();
          
          lens.css(lensCss);
          lens.show();
        },
        onZoomOut: function() {
          var lens = $this.find('.hover-zoom-lens');
          
          $this.removeClass('on-zoom');
          $('.zoomedMainContainer').hide();
          $('.prod-order-container').show();
          lens.hide();
          
        }
      }
      
      return zoomOptions;
    }
        
    desktopZoom.mouseleave(function() {
      var $this = $(this)
      
      if($this.hasClass('on-zoom')) {
        $this.trigger('click')
      }
    })
    
    
    
    desktopZoom.each((index, element) => {
      var $this = $(element),
          options = zoomOptions($this);
      
        $this.zoom(options)
    })
    
    desktopZoom.mousemove(function(e) {
      var x, y;
      var img = $(this).find('img').get(0),
          pos = getCursorPos(e, img),
          lens = $(this).find('.hover-zoom-lens').get(0);
      
      e.preventDefault();
      
      if($(this).hasClass('on-zoom')) {
        /*calculate the position of the lens:*/
        x = pos.x - (lens.offsetWidth / 2);
        y = pos.y - (lens.offsetHeight / 2);

        /*prevent the lens from being positioned outside the image:*/
        if (x > img.width - lens.offsetWidth) {x = img.width - lens.offsetWidth;}
        if (x < 0) {x = 0;}
        if (y > img.height - lens.offsetHeight) {y = img.height - lens.offsetHeight;}
        if (y < 0) {y = 0;}

        lens.style.left = x + "px";
        lens.style.top = y + "px";
      }
    })
    
    function getCursorPos(e, img) {
      var a, x = 0, y = 0;
      e = e || window.event;
      /*get the x and y positions of the image:*/
      a = img.getBoundingClientRect();
      /*calculate the cursor's x and y coordinates, relative to the image:*/
      x = e.pageX - a.left;
      y = e.pageY - a.top;
      /*consider any page scrolling:*/
      x = x - window.pageXOffset;
      y = y - window.pageYOffset;
      return {x : x, y : y};
    }
  }

  
  function updateTitle(title) {
    $('.prod-order-section .prod-title').text(title);
  }

   function enableMobileZoom() {
    if (window.innerWidth < 768) {
      const images = document.querySelectorAll('.js-mobile-zoom');

    images.forEach(image => {
        let scale = 1;
        let startDistance = 0;

        image.addEventListener('touchstart', function(e) {
            if (e.touches.length === 2) {
                startDistance = getDistance(e.touches[0], e.touches[1]);
            }
        });

        image.addEventListener('touchmove', function(e) {
            if (e.touches.length === 2) {
                const currentDistance = getDistance(e.touches[0], e.touches[1]);
                scale *= currentDistance / startDistance;
                startDistance = currentDistance;

                image.style.transform = `scale(${scale})`;
                image.style.transition = 'transform 0.1s';
            }
        });

        image.addEventListener('touchend', function(e) {
            if (e.touches.length < 2) {
                startDistance = 0;
                scale = 1; // Reset scale to original
                image.style.transform = 'scale(1)'; // Reset transform to original
            }
        });

        function getDistance(touch1, touch2) {
            const dx = touch1.clientX - touch2.clientX;
            const dy = touch1.clientY - touch2.clientY;
            return Math.sqrt(dx * dx + dy * dy);
        }
    });
    }
  }

  $(window).resize(function() {
    if (window.location.pathname.includes('products')) {
      enableMobileZoom();
    }
  });

})(jQuery)
